import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const CGUPage = () => {
  return (
    <MainLayout>
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold text-center mb-8">Conditions Générales d'Utilisation</h1>
        
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle>Conditions d'utilisation de NautiCoach</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">Article 1 – Objet</h2>
              <p className="text-muted-foreground">
                Les présentes Conditions Générales d'Utilisation (CGU) définissent les modalités d'accès et d'utilisation de la plateforme NautiCoach, application de gestion nautique destinée aux propriétaires de bateaux de plaisance.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 2 – Accès au service</h2>
              <p className="text-muted-foreground">
                L'accès à NautiCoach nécessite la création d'un compte utilisateur. L'Utilisateur s'engage à fournir des informations exactes et à jour lors de son inscription. L'Utilisateur est seul responsable de la confidentialité de ses identifiants de connexion.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 3 – Description des services</h2>
              <p className="text-muted-foreground mb-2">
                NautiCoach propose les fonctionnalités suivantes :
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>Gestion de l'inventaire et des équipements du navire</li>
                <li>Planification et suivi des maintenances préventives</li>
                <li>Checklists de navigation et de sécurité</li>
                <li>Assistant IA nautique pour conseils et recommandations</li>
                <li>Génération de listes d'avitaillement</li>
                <li>Gestion multi-navires</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 4 – Obligations de l'Utilisateur</h2>
              <p className="text-muted-foreground mb-2">
                L'Utilisateur s'engage à :
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>Utiliser le service conformément à sa destination et aux présentes CGU</li>
                <li>Ne pas tenter de porter atteinte au fonctionnement de la plateforme</li>
                <li>Respecter la propriété intellectuelle de NautiCoach</li>
                <li>Ne pas utiliser le service à des fins illicites</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 5 – Limitation de responsabilité et exclusion de garantie</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium mb-2">5.1 – Rôle de l'Assistant IA et de l'Application</h3>
                  <p className="text-muted-foreground">
                    L'Utilisateur reconnaît que NautiCoach est un outil numérique d'aide à la gestion, à l'inventaire et à la maintenance préventive. Les conseils, checklists, analyses météo ou diagnostics techniques générés par l'Intelligence Artificielle (IA) sont fournis à titre purement indicatif et ne constituent en aucun cas une expertise certifiée ou une obligation de résultat.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium mb-2">5.2 – Responsabilité du "Chef de Bord"</h3>
                  <p className="text-muted-foreground mb-2">
                    Conformément aux réglementations maritimes en vigueur (notamment la Division 240 en France), l'Utilisateur conserve en toutes circonstances la qualité et les responsabilités de Chef de Bord. Il est seul responsable :
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1">
                    <li>De la conduite du navire et de la sécurité de l'équipage</li>
                    <li>De la vérification visuelle et physique de l'état du navire (vannes de coque, gréement, moteur, équipements de sécurité)</li>
                    <li>De la décision finale de prendre la mer ou d'effectuer une manœuvre</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium mb-2">5.3 – Exclusions spécifiques</h3>
                  <p className="text-muted-foreground mb-2">
                    La responsabilité de l'Éditeur (NautiCoach) ne pourra être engagée, à quelque titre que ce soit, pour :
                  </p>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1">
                    <li><strong>Sinistres en mer :</strong> Naufrage, échouage, collision ou avarie moteur survenus suite à l'utilisation (ou la non-utilisation) d'une checklist ou d'un conseil de l'IA</li>
                    <li><strong>Défaut de Maintenance :</strong> Oubli d'une tâche de maintenance, même si celle-ci n'a pas été notifiée par l'application</li>
                    <li><strong>Données Erronées :</strong> Erreurs provenant de sources tierces (données météo, capteurs IoT connectés, informations constructeurs)</li>
                    <li><strong>Dommages Indirects :</strong> Perte d'exploitation, frais de remorquage, frais de réparation ou perte de jouissance du navire</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium mb-2">5.4 – Absence de garantie</h3>
                  <p className="text-muted-foreground">
                    L'Éditeur ne garantit pas que l'Application est exempte d'erreurs, de bugs ou d'interruptions de service. L'Utilisateur accepte d'utiliser le service "en l'état" et reconnaît que la navigation de plaisance comporte des risques intrinsèques que l'Application ne peut éliminer.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 6 – Propriété intellectuelle</h2>
              <p className="text-muted-foreground">
                L'ensemble des éléments de la plateforme NautiCoach (textes, graphiques, logos, icônes, logiciels, base de données) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation ou exploitation non autorisée est strictement interdite.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 7 – Données personnelles</h2>
              <p className="text-muted-foreground">
                Le traitement des données personnelles est régi par notre <a href="/politique-confidentialite" className="text-primary underline hover:text-primary/80">Politique de Confidentialité</a>. L'Utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données conformément au RGPD.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 8 – Résiliation</h2>
              <p className="text-muted-foreground">
                L'Utilisateur peut résilier son compte à tout moment depuis son espace personnel. L'Éditeur se réserve le droit de suspendre ou supprimer un compte en cas de violation des présentes CGU.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 9 – Modification des CGU</h2>
              <p className="text-muted-foreground">
                L'Éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur publication sur la plateforme. L'utilisation continue du service après modification vaut acceptation des nouvelles conditions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Article 10 – Droit applicable</h2>
              <p className="text-muted-foreground">
                Les présentes CGU sont soumises au droit français. Tout litige relatif à l'interprétation ou à l'exécution des présentes sera porté devant les tribunaux compétents français.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default CGUPage;
